import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const SITE_URL = "https://lionpridefinancial.com";

const routeSeo = {
  "/": {
    title: "Lion Pride Financial | Business Owner Financial Planning & Insurance Strategies",
    description:
      "Lion Pride Financial helps business owners and families explore insurance-based planning, retirement income, exit strategy, and liquidity solutions.",
    canonical: `${SITE_URL}/`,
    type: "website",
  },
  "/publications": {
    title: "Publications | Lion Pride Financial",
    description:
      "Read Lion Pride Financial publications on cash balance plans, business exit planning, retirement income, liquidity strategies, and protection planning.",
    canonical: `${SITE_URL}/publications/`,
    type: "website",
  },
  "/privacy": {
    title: "Privacy Policy | Lion Pride Financial",
    description:
      "Read how Lion Pride Financial handles privacy, website forms, contact submissions, and client inquiry information.",
    canonical: `${SITE_URL}/privacy`,
    type: "article",
  },
  "/terms": {
    title: "Terms of Service | Lion Pride Financial",
    description:
      "Review the terms governing Lion Pride Financial services and commercial SEC Intelligence subscriptions.",
    canonical: `${SITE_URL}/terms`,
    type: "article",
  },
};

function upsertMeta(selector, attrs) {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement("meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([key, value]) => el.setAttribute(key, value));
}

function upsertLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

export default function SiteSeo() {
  const location = useLocation();

  useEffect(() => {
    const pathname =
      location.pathname !== "/" && location.pathname.endsWith("/")
        ? location.pathname.slice(0, -1)
        : location.pathname;

    const seo = routeSeo[pathname];

    // Unknown single-slug routes are publication/article pages. Their initial
    // HTML shell may already contain page-specific metadata from the publisher,
    // and PublicationArticle refreshes it after the API load. Do not overwrite
    // those pages with home-page metadata on first React mount.
    if (!seo) return;

    const image = `${SITE_URL}/logo.png`;
    document.title = seo.title;
    upsertMeta('meta[name="description"]', { name: "description", content: seo.description });
    upsertMeta('meta[name="robots"]', { name: "robots", content: "index, follow, max-image-preview:large" });
    upsertMeta('meta[property="og:title"]', { property: "og:title", content: seo.title });
    upsertMeta('meta[property="og:description"]', { property: "og:description", content: seo.description });
    upsertMeta('meta[property="og:url"]', { property: "og:url", content: seo.canonical });
    upsertMeta('meta[property="og:type"]', { property: "og:type", content: seo.type });
    upsertMeta('meta[property="og:site_name"]', { property: "og:site_name", content: "Lion Pride Financial" });
    upsertMeta('meta[property="og:image"]', { property: "og:image", content: image });
    upsertMeta('meta[name="twitter:card"]', { name: "twitter:card", content: "summary_large_image" });
    upsertMeta('meta[name="twitter:title"]', { name: "twitter:title", content: seo.title });
    upsertMeta('meta[name="twitter:description"]', { name: "twitter:description", content: seo.description });
    upsertMeta('meta[name="twitter:image"]', { name: "twitter:image", content: image });
    upsertLink("canonical", seo.canonical);
  }, [location.pathname]);

  return null;
}
